import React, { Component } from 'react'

import styles from './Box2.module.css'

export default class Rect extends Component {
  render() {
    const { bbox, cmap, imageSize, hovered, mask } = this.props
    const { x, y, x2, y2, label } = bbox
    const { imageWidth, imageHeight } = imageSize

    const dimensions = {
      left: x > x2 ? Math.round(x2 * imageWidth) : Math.round(x * imageWidth),
      top: y > y2 ? Math.round(y2 * imageHeight) : Math.round(y * imageHeight),
      width: Math.abs(Math.round((x2 - x) * imageWidth)),
      height: Math.abs(Math.round((y2 - y) * imageHeight))
    }

    let boxColor = (cmap && cmap[label]) || 'white'
    if (mask == true || label == undefined){
      boxColor = 'blue';
    }

    return (
      <div
        //className={hovered ? styles.wrapperHover : styles.wrapper}
        className={styles.wrapper}
        style={dimensions}
      >
        <div className={styles.draw} style={{ border: boxColor == 'blue' ? '2px solid white' : '', borderColor: boxColor }} />
        <div className={styles.inline} />
        <div className={styles.outline} />
        <div className={styles.fill} style={{ backgroundColor: ( mask || label == undefined) ? 'transparent' : boxColor }} />
      </div>
    )
  }
}
